import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TitlesProfile from '../TitlesProfile';
import { isMobile } from 'react-device-detect'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  card: {
    marginBottom: 24,
    maxWidth: 840,
    padding: isMobile ? '24px 8px 24px 15px' : 24,
    boxShadow:' 0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  cardHeader: {
    display: 'block',
    paddingBottom: 0,
    width: '80%',
    '&:after': {
      content: '""',
      display: 'block',
      margin: '0 auto',
      width: '100%',
      paddingTop: '8px',
      borderBottom: '1px solid #c1c1c1',
    },
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#10587f',
  },
  cardSubTitle: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#484848',
  },
  noPadding: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    }
    
  },
});

const CardProfile = props => {
  const { title, subTitle, awardIcon, status } = props;
  
  const classes = useStyles();

  return (
    <>
      <Card className={classes.card}>
        <TitlesProfile title={title} subtitle={subTitle} status={status} awardIcon={awardIcon} />
        <CardContent classes={{ root: classes.noPadding }}>
          {props.children}
        </CardContent>
      </Card>
    </>
  );
};

/* 
const TitlesProfile = (props) => {
    const{title,subtitle } =props
    return ( 
        <>
        <div
        style={{
          display: 'flex',
          flexFlow: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ width: '100%', maxWidth: 704 }}>
          <Typography
            style={{ fontWeight: 'bold', color: '#10587f', fontSize: 22 }}
          >
            {title}
          </Typography>
          <Typography
            style={{ fontWeight: 'normal', color: '#10587f', fontSize: 16 }}
          >
            {subtitle}
          </Typography>
        </div>
        <div>
          <div id="award_img" style={{ width: 40, height: 40 }}>
            <img src="../img/profile/award.svg" alt="" />
          </div>
        </div>
       
         <Typography
          style={{ fontWeight: 'normal', color: '#10587f', fontSize: 14 }}
        >
          {subtitle2}
        </Typography> 
      </div>
      <div style={{ maxWidth: '100%' }}>
            <hr
            style={{ height: 1, backgroundColor: '#c1c1c1', marginTop: 8 }}
            ></hr>
        </div>
      </>
     );
}
  */

export default CardProfile;
